export default function WeightIco({ color }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 0.0498047C10.7475 0.0498217 12.166 1.42363 12.166 3.1084C12.166 3.53896 12.0733 3.94929 11.9062 4.32129L11.875 4.3916H14.1973C15.1326 4.39169 15.9312 5.03903 16.0957 5.92578L17.9199 15.7588C18.0205 16.3011 17.8673 16.8592 17.501 17.2822C17.1346 17.7053 16.5923 17.9502 16.0205 17.9502H1.97949C1.40775 17.9502 0.865365 17.7053 0.499023 17.2822C0.132767 16.8592 -0.020486 16.3011 0.0800781 15.7588L1.9043 5.92578C2.06882 5.03901 2.8673 4.39166 3.80273 4.3916H6.125L6.09375 4.32129C5.92679 3.94929 5.83398 3.53896 5.83398 3.1084C5.83402 1.42362 7.25248 0.0498047 9 0.0498047ZM3.75391 6.24512L1.92969 16.0781L1.91895 16.1367H16.0811L16.0703 16.0781L14.2461 6.24512L14.2383 6.2041H3.76172L3.75391 6.24512ZM9 1.86328C8.29192 1.86328 7.71293 2.41993 7.71289 3.1084C7.71289 3.79689 8.29183 4.35449 9 4.35449C9.70816 4.35448 10.2871 3.79688 10.2871 3.1084C10.2871 2.41994 9.70813 1.8633 9 1.86328Z"
        fill={color || "#8396A8"}
        stroke="white"
        stroke-width="0.1"
      />
    </svg>
  );
}
